import type { LensTheme } from '@diligentcorp/atlas-theme-mui-lens';
import { StatusIndicator } from '@diligentcorp/atlas-theme-mui-lens';
import { Box, Typography, useTheme } from '@mui/material';
import React from 'react';
import type { CustomField } from '../CustomFields';
import { customFieldStatusColorMap } from '../customFieldStatusColorMap';

const STATUS_LABELS: Record<string, string> = {
  ACTIVE: 'Active',
  INACTIVE: 'Retired',
};

interface Props {
  field: CustomField;
}

export const CustomFieldDrawerTitle: React.FC<Props> = ({ field }) => {
  const { tokens } = useTheme<LensTheme>();

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
      <Typography
        component="span"
        sx={{
          fontSize: '24px',
          fontWeight: tokens.semantic.fontWeight.emphasis.value,
          color: tokens.semantic.color.type.default.value,
        }}
      >
        {field.label}
      </Typography>
      <StatusIndicator
        label={STATUS_LABELS[field.status] || field.status}
        customColor={customFieldStatusColorMap(field.status)}
        size="small"
      />
    </Box>
  );
};
